import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoIsFor() {
  const isFor = ['Padres y madres de niños entre 2 y 6 años.', 'Personas que se sienten agotadas por la intensidad emocional de sus hijos.', 'Padres que quieren dejar de gritar pero no saben cómo poner límites con calma.', 'Quienes sienten ansiedad o vergüenza ante los berrinches en lugares públicos.'];
  const isNotFor = ['Personas que buscan disciplina basada en el miedo o castigos físicos.', 'Padres que no están dispuestos a agacharse y ponerse al nivel visual de su hijo.', "Quienes buscan una 'fórmula mágica' que elimine las emociones naturales de un niño."];
  return <section className="py-24 bg-cream-dark" data-id="element-225">
      <div className="max-w-6xl mx-auto px-6 lg:px-8" data-id="element-226">
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-227">
          <FadeIn direction="right" data-id="element-228">
            <div className="bg-white p-8 lg:p-10 rounded-3xl shadow-sm border-t-4 border-sage-500 h-full" data-id="element-229">
              <h3 className="text-2xl font-bold mb-8 text-charcoal flex items-center gap-3" data-id="element-230">
                <CheckCircle2 className="text-sage-500" size={28} data-id="element-231" />
                Este método ES para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-232">
                {isFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-233">
                    <div className="mt-1 flex-shrink-0 w-6 h-6 rounded-full bg-sage-100 flex items-center justify-center text-sage-600" data-id="element-234">
                      <CheckCircle2 size={16} data-id="element-235" />
                    </div>
                    <span className="text-charcoal-light leading-relaxed" data-id="element-236">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn direction="left" delay={0.2} data-id="element-237">
            <div className="bg-white p-8 lg:p-10 rounded-3xl shadow-sm border-t-4 border-terracotta h-full opacity-90" data-id="element-238">
              <h3 className="text-2xl font-bold mb-8 text-charcoal flex items-center gap-3" data-id="element-239">
                <XCircle className="text-terracotta" size={28} data-id="element-240" />
                Este método NO es para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-241">
                {isNotFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-242">
                    <div className="mt-1 flex-shrink-0 w-6 h-6 rounded-full bg-terracotta-light flex items-center justify-center text-terracotta" data-id="element-243">
                      <XCircle size={16} data-id="element-244" />
                    </div>
                    <span className="text-charcoal-light leading-relaxed" data-id="element-245">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}